import { BodyResearchMetric } from 'practice/view-models/research-metric';
import { HeadCell } from 'shell/components/shared/table/types';

export const headCells: HeadCell<BodyResearchMetric, keyof BodyResearchMetric>[] = [
  {
    id: 'register',
    label: 'Registro',
  },
  {
    id: 'practice',
    label: 'Pratica',
  },
  {
    id: 'operation',
    label: 'Operazione',
  },
  {
    id: 'state',
    label: 'Stato',
  },
  {
    id: 'validityFrom',
    label: 'Validità dal',
  },
  {
    id: 'validityTo',
    label: 'Validità al',
  },
  {
    id: 'hoursMax',
    label: 'Nr. max ore per operazione',
  },
  {
    id: 'hoursWarning',
    label: 'Nr. ore per warning',
  },
  {
    id: 'action',
    label: '',
  },
];
